/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Column } from '../../tracking-list';
import { ColumnCommonProps } from '../survey-question-list';

interface ColumnTitleProps extends Pick<ColumnCommonProps, 'question' | 'alternativeCode' | 'preferredAltCodes'> {
  handleGoToQuestion?: () => void
}

const getTitle = (p: ColumnTitleProps) => {
  const { question, alternativeCode, preferredAltCodes } = p;
  const universalTracker = question.universalTracker;

  if (Array.isArray(preferredAltCodes)) {
    for (const code of preferredAltCodes) {
      if (universalTracker.hasAlternativeInfo(code)) {
        return universalTracker.getName(code)
      }
    }
  }

  return universalTracker.getName(alternativeCode);
}

export const ColumnTitle = (props: ColumnTitleProps) => {
  const fullTitle = getTitle(props);

  return (
    <Column className='pl-2' fill truncateTwoline tooltip={fullTitle} onClick={props.handleGoToQuestion}>
      {fullTitle}
    </Column>
  );
}
